import { cloneDeep } from 'lodash';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import { CHAT_BRAND } from 'src/constants/branding';

const byUsefulLevel = [
  { name: 'Answers', children: ['Help Center', 'Audiences', 'Keyword Groups', 'Languages'] },
  { name: 'People', children: ['Users', 'Teams', 'Roles'] },
  {
    name: 'Channels',
    children: [
      'Custom Channels',
      'Email',
      CHAT_BRAND.name,
      'Voice',
      'IVR',
      'SMS',
      'Facebook Pages',
      'Instagram',
      'Instagram Messaging',
      'Twitter Direct Messages',
      'WhatsApp',
    ],
  },
  { name: 'Agent Experience', children: ['Agent Status', 'Relationships', 'Idle Timing', 'Conversation Workflow'] },
  {
    name: 'App Developer Tools',
    children: ['App Actions', 'Apps', 'Webhooks', 'API Tokens', 'Lookup Adapter Debugger'],
  },
  {
    name: 'Orchestration',
    children: [
      'Rules',
      'Business Hours',
      'People Match',
      'Skills',
      'Topics',
      'Freeform Topics',
      'Inboxes',
      'Mobile Phone Number Identification',
      'Entry Points',
      'Self-Service Threads',
    ],
  },
  {
    name: 'Proactive Conversations',
    children: ['Proactive Chat Settings', 'Proactive Chat', 'Proactive Voice', 'Proactive SMS', 'Proactive Email'],
  },
  { name: 'Security and Compliance', children: ['Compliance Event Log', 'Customer Data Retention', 'Single Sign-On'] },
  { name: 'Insights', children: ['Scheduled Reports', 'SLA Business Hours'] },
  { name: 'Sidekick', children: ['Threads'] },
];

// Variant A – alphabetical: All sections and corresponding list items are sorted A–Z
const sortedNavItems = map(sortBy(cloneDeep(byUsefulLevel), ['name']), (section: any) => ({
  ...section,
  children: section.children.sort(),
}));

export { sortedNavItems };
